<template>
	<div>
		<div style="width: 100%;margin-bottom: 20px;">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>持仓分析</el-breadcrumb-item>
			</el-breadcrumb>
		</div>

		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search" :model="formInline" size="small">
			<el-form-item label="债券代码">
				<el-input v-model="formInline.bondCode"></el-input>
			</el-form-item>
			<el-form-item label="银行">
				<el-select v-model="formInline.city" placeholder="选择银行" clearable>
					<el-option :label="item" :value="item" v-for="(item,key) in manageCityList"
						:key="key">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="日期">
					<el-date-picker v-model="formInline.analysisDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
					</el-date-picker>
				</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
				<el-button size="small" type="warning" @click="exportData">导出</el-button>
			</el-form-item>
		</el-form>

		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;" @selection-change="handleSelectionChange"
			:row-style='changeRowBgColor'>
			<el-table-column sortable prop="bondCode" label="债券代码" width="100" align="center"></el-table-column>
			<el-table-column prop="city" label="地区" align="center"></el-table-column>

			<el-table-column prop="buyTradingDate" label="买入日期" align="center"></el-table-column>
			<el-table-column prop="buyDate" label="结算日期" align="center"></el-table-column>
			<el-table-column prop="buyNetPrice" label="净价" align="center"></el-table-column>
			<el-table-column prop="buyFullPrice" label="全价" align="center"></el-table-column>
			<el-table-column prop="buyValue" label="收益率" align="center"></el-table-column>
			<el-table-column prop="buyVolume" label="买入量" align="center"></el-table-column>
			<el-table-column prop="sellTradingDate" label="卖出日期" align="center"></el-table-column>
			<el-table-column prop="sellDate" label="结算日期" align="center"></el-table-column>
			<el-table-column prop="sellNetPrice" label="净价" align="center"></el-table-column>
			<el-table-column prop="sellFullPrice" label="全价" align="center"></el-table-column>
			<el-table-column prop="sellValue" label="收益率" align="center"></el-table-column>

			<el-table-column prop="priceDiff" label="价差" align="center"></el-table-column>
			<el-table-column prop="totalIncome" label="总收入" align="center"></el-table-column>
			<el-table-column prop="capitalGains" label="资本利得" align="center"></el-table-column>
			<el-table-column prop="interestIncome" label="利息收入" align="center"></el-table-column>
			<el-table-column prop="interestPayed" label="票息兑付" align="center"></el-table-column>
			<el-table-column prop="isHold" label="是否持仓" align="center"></el-table-column>
		</el-table>
		

		<!-- 分页组件 -->
		<Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>

		<div v-if="analysisMap">
			<el-card shadow="never" >
				<el-row>
					<el-col :span="4">
						<div>天数：{{analysisMap.tianshu}}</div>
					</el-col>
					<el-col :span="4">
						<div>头寸（亿）：{{towNumber(analysisMap.toucun/100000000,4)}}</div>
					</el-col>
					<el-col :span="4">
						<div>净值：{{towNumber(analysisMap.jingzhi,4)}}</div>
					</el-col>
					<el-col :span="4">
						<div>收益率：{{towNumber(analysisMap.shouyilv,6)}}%</div>
					</el-col>
					<el-col :span="4">
						<div>收益率(除持仓资本利得)：{{towNumber(analysisMap.shouyilv2,6)}}%</div>
					</el-col>
					<el-col :span="4">
						<div>收益率3：{{towNumber(analysisMap.shouyilv3,6)}}%</div>
					</el-col>
				</el-row>
			</el-card>

			<el-card shadow="never">
				<el-row>
					<el-col :span="4">
						<div>持仓规模(亿)：{{towNumber(analysisMap.chicangguimo/100000000,2)}}</div>
					</el-col>
					<el-col :span="4">
						<div>价差小计[万]：{{towNumber(analysisMap.jiachaxiaoji/10000,4)}}</div>
					</el-col>
					<el-col :span="4">
						<div>票息兑付小计[万]：{{towNumber(analysisMap.piaoxiduifuxiaoji/10000,4)}}</div>
					</el-col>
					<el-col :span="4">
						<div>资本利得小计[万]：{{towNumber(analysisMap.zibenlidexiaoji/10000,4)}}</div>
					</el-col>
					<el-col :span="4">
						<div>资本利得[交易]小计[万]：{{towNumber(analysisMap.zibenlidejiaoyixiaoji/10000,4)}}</div>
					</el-col>
					<el-col :span="4">
						<div>利息收入小计[万]：{{towNumber(analysisMap.lixishouruxiaoji/10000,4)}}</div>
					</el-col>
				</el-row>
			</el-card>


			<el-card shadow="never">
				<el-row>
					<el-col :span="4">
						<div>回购小计[万]：{{towNumber(analysisMap.huigouxiaoji/10000,4)}}</div>
					</el-col>
					<el-col :span="4">
						<div>正回购总额：{{towNumber(analysisMap.zhenghuigouzonge)}}</div>
					</el-col>
					<el-col :span="4">
						<div>正回购支出：{{towNumber(analysisMap.zhenghuigouzhichu,0)}}</div>
					</el-col>
					<el-col :span="4">
						<div>逆回购总额：{{towNumber(analysisMap.nihuigouzonge,2)}}</div>
					</el-col>
					<el-col :span="4">
						<div>逆回购收入：{{towNumber(analysisMap.nihuigoushouru,2)}}</div>
					</el-col>
					<el-col :span="4">
						<div>历史正/逆回购：{{towNumber(analysisMap.lishizhenghuigouzhichu,2)}}/{{towNumber(analysisMap.lishinihuigoushouru,2)}}</div>
					</el-col>
				</el-row>
			</el-card>

			<el-card shadow="never">
				<el-row>
					<el-col :span="4">
						<div>总计[万]：{{towNumber(analysisMap.zj/10000,4)}}</div>
					</el-col>
					<el-col :span="4">
						<div>总计(除持仓资本利得)[万]：{{towNumber(analysisMap.zj2/10000,4)}}</div>
					</el-col>
				</el-row>
			</el-card>
		</div>


		<div style='color:red'>
            <div>总计=价差小计+票息兑付小计+回购小计</div>
            <div>总计(除持仓资本利得)=总计-持仓资本利得小计</div>
            <div>收益率=总计*365*100/天数/头寸</div>
            <div>收益率(除持仓资本利得)=总计(除持仓资本利得)*365*100/天数/头寸</div>
            <div>净值=（头寸 + 总计)/ 头寸</div>
        </div>

		<div><hr></div>
		
		<div style='color:red'>
            <div>*节假日及非交易日净值及收益率可能存在误差</div>
            <div><hr></div>
        </div>


	</div>
</template>


<script>
	import {
		getAllCity,
		getManageCity,
		getBondHoldAnalysisList,
		getBondHoldAnalysisListExport,
		getBondHoldAnalysis
	} from '../../api/basisMG.js'
	// import methodsMixin from '@/utils/methodsMixin'
	// 导出模块
	export default {
		// mixins: [methodsMixin],

		// 模块数据
		data() {
			//数据  
			return {
				cityList: [],
				manageCityList:[],
				analysisMap:{},
				listData: [],

				businessType:'normal',
				alldata: false,
				checkAll: false,
				isIndeterminate: true,
				checkedLimit: [],
				manageWarehouseShow: false,
				manageWarehouseIds: '',


				warehouseVisible: false,
				warehouseName: '',
				warehouseId: '',
				vipList: [],
				agentList: [],
				tagList: [],
				loading: false,
				Visible: false,
				time: [],
				checkboxGroup: [],
				type: 'showVip',
				fileList: [],

				dialogImageUrl: '',
				dialogVisible: false,
				uids: '',
				tagIds: '',
				vipName: '',
				agentName: '',
				vipLevel: '',
				agentLevel: '',
				// 所属分类
				tableData: [],
				value: [],
				editForm: {},
				selectEditForm: {},
				usernames: ''
			}
		},
		watch: {},
		methods: {
			towNumber(val,len) {
				return parseFloat(val).toFixed(len)    
			},
			changeRowBgColor({ row }) { 
				let styleJson = {}
				if (row.isHold === 1){
				styleJson = { "color": "red" };} 
				return styleJson
			},
			exportData() {
				let param = this.formInline
				getBondHoldAnalysisListExport(param)
			},



			checkboxChange(val) {
				console.log(val)
				this.tagIds = val.join(",")
			},
			handlewarehousechange(val) {
				console.log(val)
				if (val) {
					this.WarehouseList.forEach(item => {
						if (item.id == val) {
							this.warehouseName = item.warehouseName
						}
					})
				} else {
					this.warehouseName = ''
				}
				console.log(this.warehouseName)

			},
			changgeTime2(time) {
				console.log(time)
				if (time.length) {
					this.formInline.registerStart = time[0]
					if (time.length > 1) {
						this.formInline.registerEnd = time[1]
					}
				} else {
					this.formInline.registerStart = ''
					this.formInline.registerEnd = ''
				}

			},
			handleClickName(row) {
				console.log(row)
				// JSON.stringify(row)
				this.$router.push({
					path: '/user/userDetail',
					query: {
						uid: row.uid
					}
				})
				// this.getsingleUserInfo(row)
			},

			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log('handleSelectionChange', val)
				let arr = []
				if (val.length == 1) {
					this.selectEditForm = val[0]

				} else {
					this.selectEditForm = {}

				}
				this.checkedLimit = []
				this.alldata = false
				let userNameList = []
				this.multipleSelection.map(item => {
					arr.push(item.uid)
					userNameList.push(item.username)
				})

				this.uids = arr.join(",")
				this.usernames = userNameList.join(",")
			},
			// 获得用户数据
			getdata() {
				let param = this.formInline
				getBondHoldAnalysisList(param).then(res => {
					this.saveParams(this.$route.path,param)
					if (res.code == '200') {
						this.listData = res.data.content
						this.pageparm.total = res.data.totalElements
					}
				})

				getBondHoldAnalysis(param).then(res => {
					if (res.code == '200') {
						this.analysisMap = res.data
					}
				})
			},
			getAllCity() {
				getAllCity().then(res => {
					if (res.code == '200') {
						this.cityList = res.data
					}
				})
				getManageCity().then(res => {
					if (res.code == '200') {
						this.manageCityList = res.data
						console.log("this.cityList",this.cityList)
					}
				})
			},




			handleedit(row) {
				this.checkboxGroup = []
				console.log(row)
				this.dialogVisible = true
				this.uids = row.uid
				this.type = "tag"
			},
			handleedit1() {
				if (this.uids == '') {
					this.$message.error('请选择用户')
					return
				} else {
					this.checkboxGroup = []
					this.dialogVisible = true
					this.type = "tag"
				}
			},
		},
		// 创建前状态(里面是操作)
		beforeCreate() { },
		// 创建完毕状态(里面是操作)
		created() {
			this.getParams(this.$route.path)
			this.getdata()
			this.getAllCity()
		},
		// 挂载前状态(里面是操作)
		beforeMount() { },
		// 挂载结束状态(里面是操作)
		mounted() { },
		// 更新前状态(里面是操作)
		beforeUpdate() { },
		// 更新完成状态(里面是操作)
		updated() { },
		// 销毁前状态(里面是操作)
		beforeDestroy() { },
		// 销毁完成状态(里面是操作)
		destroyed() { }
	};
</script>

<style scoped>
	.el-form-item {
		width: 30%;
		box-sizing: border-box;
	}

	.just-start {
		display: flex;
		justify-content: flex-start;
	}

	.marginT20 {
		margin-top: 20px;
	}
</style>